<template>
  <dc-layout-main :is-breadcrumb="true">
    <dc-layout-content>
      <cos-table serial :columns="columns" @fetch="fetch" v-model:search="queryForm" ref="tableRef" tableId="DcCosRatingRules">
        <template #bodyCell="{ column, record }">
          <template v-if="column.dataIndex === 'action'">
            <more-button>
              <a-button type="link" @click="addEdit(record)" v-permission="pageType === 'volumeOfBusinessLevel' ? 'fbu_volbuslevel_edit_btn' : 'fbu_ratingrules_edit_btn'">编辑</a-button>
              <a-button type="link" @click="deleteRow(record)" v-permission="pageType === 'volumeOfBusinessLevel' ? 'fbu_volbuslevel_delete_btn' : 'fbu_ratingrules_delete_btn'">删除</a-button>
            </more-button>
          </template>
        </template>
        <template #button>
          <a-button type="primary" @click="addEdit()" v-permission="pageType === 'volumeOfBusinessLevel' ? 'fbu_volbuslevel_add_btn' : 'fbu_ratingrules_add_btn'">新增</a-button>
        </template>
      </cos-table>
      <editModal ref="editModalRef" :pageType="pageType" @success="success" />
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts">
import editModal from './components/editModal.vue'
import Modal from '@/hooks/modalType'
import { reactive, ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { ratingRulesFindByPage, ratingRulesDelete } from '@/api/gucangSales/ratingRules'
import { PageType } from './hooks/enum'
import { RatingRulesSaveParams } from '@/typings/api/gucangSale'
import { DcMessage } from '@dc-platform/dc-components'

export default { name: 'DcCosFbuRatingRules' }
</script>
<script setup lang="ts">
const route = useRoute()
const editModalRef = ref<{ toggle:(row?: RatingRulesSaveParams) => void }>()
const pageType = computed(() => route.path.split('/').pop() || 'ratingRules')
const columns = ref([
  { title: '客户评级', dataIndex: 'configName' },
  { title: '评分区间', dataIndex: 'logic' },
  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const getData = () => {
  if (pageType.value === 'volumeOfBusinessLevel') {
    columns.value = [
      { title: '档次', dataIndex: 'configName' },
      { title: pageType.value === 'volumeOfBusinessLevel' ? '成交额(万/RMB)' : '关联客户代码', dataIndex: 'logic' },
      {
        title: '操作',
        dataIndex: 'action',
        fixed: 'right'
      }
    ]
  }
}
const tableRef = ref()
const queryForm = reactive({
  name: ''
})
getData()

// 获取列表
const fetch = (params: object, callBack: (res: any) => void) => {
  if (pageType.value === 'volumeOfBusinessLevel') {
    ratingRulesFindByPage({ ...params, configType: PageType.LEVEL, appId: 'cos_fbu' }).then((res) => {
      callBack(res)
    })
  } else {
    ratingRulesFindByPage({ ...params, configType: PageType.RULE, appId: 'cos_fbu' }).then((res) => {
      callBack(res)
    })
  }
}
const success = () => {
  tableRef.value.fetch()
}

const addEdit = (_row?: RatingRulesSaveParams) => {
  editModalRef.value?.toggle(_row)
}
const deleteRow = (row: RatingRulesSaveParams) => {
  Modal.delete({
    name: row.configName,
    onOk() {
      ratingRulesDelete({ id: row.id }).then(() => {
        DcMessage.success('删除成功')
        tableRef.value.fetch()
      })
    }
  })
}
</script>

<style scoped></style>
